import React from 'react'


export const Objetive = ({objetive_info}) => {
  return (
    <div className="d-flex flex-column">
        <h2 className="text-center">Objetivo:</h2>
        <p className="text-justify">{objetive_info}</p>
    </div>
  )
}
